import { catchError, EMPTY } from "rxjs";
import { EnumPages } from "../enum/pages";
import { EnumPath } from "../enum/path";
import { Route } from "../models/route";
import {
  PERMITION_MESSAGES,
  PERMITION_PROFILE,
  PERMITION_SETTINGS,
  PERMITION_USERS,
  PERMITION_SETTINGS_PARAMETER,
  PERMITION_SETTINGS_PARAMETER_READ,
  PERMITION_SETTINGS_PARAMETER_UPDATE,
  PERMITION_BANNERS_UPDATE,
  PERMITION_BANNERS_CREATE,
  PERMITION_BANNERS_READ,
  PERMITION_PROFILE_READ,
  PERMITION_PROFILE_UPDATE,
  PERMITION_PROFILE_CREATE,
  PERMITION_MESSAGES_UPDATE,
  PERMITION_MESSAGES_READ,
  PERMITION_MESSAGES_CREATE,
  PERMITION_CONSUMPTION_REPORT,
  PERMITION_CONSUMPTION_REPORT_READ,
  PERMITION_DEALERS_SETTLEMENT,
  PERMITION_BANNERS,
  PERMITION_SETTINGS_AWARD_PROGRAM,
  PERMITION_SETTINGS_AWARD_PROGRAM_READ,
  PERMITION_SETTINGS_AWARD_PROGRAM_CREATE,
  PERMITION_SETTINGS_AWARD_PROGRAM_UPDATE,
  PERMITION_ECONOMICGROUPS,
  PERMITION_ECONOMICGROUPS_CREATE,
  PERMITION_ECONOMICGROUPS_UPDATE,
  PERMITION_ECONOMICGROUPS_READ,
  PERMITION_SETTINGS_DEALERS,
  PERMITION_SETTINGS_DEALERS_CREATE,
  PERMITION_SETTINGS_DEALERS_UPDATE,
  PERMITION_SETTINGS_DEALERS_READ,
  PERMITION_SETTINGS_AWARD_PROGRAM_LOGSIMPORT,
  PERMITION_CONSORTIUM,
  PERMITION_CONSORTIUM_SALES,
  PERMITION_CONSORTIUM_SALES_SALESTABLE,
  PERMITION_CONSORTIUM_SALES_PANEL,
  PERMITION_CONSORTIUM_REPORTS_BIRTHDATE,
  PERMITION_CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT,
  PERMITION_CONSORTIUM_REPORTS,
  PERMITION_CONSORTIUM_CREDIT_ANALISYS,
  PERMITION_CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT,
  PERMITION_CONSORTIUM_RELATIONSHIP_PANEL,
  PERMITION_BANK,
  PERMITION_INSURANCE,
  PERMITION_BANK_RELATIONSHIP_PANEL,
  PERMITION_INSURANCE_RELATIONSHIP_PANEL,
  PERMITION_CONSORTIUM_REPORTS_COMMISSIONS,
  PERMITION_DEALERS_DEBTORS_READ,
  PERMITION_DEALERS_DEBTORS,
  PERMITION_CONSORTIUM_PORTAL_CONSORTIUM,
  PERMITION_REPORTS_RECEIVABLES_RECONCILIATION,
  PERMITION_REPORTS,
} from "./permitions";
import { NewconService } from "@services/newcon.service";
import { MatDialog } from "@angular/material/dialog";
import { ModalLoadingComponent } from "../components/modal/modal-loading/modal-loading.component";
import { ModalMessageComponent } from "../components/modal/modal-message/modal-message.component";
import { LOCAL_STORAGE_KEY_USER } from "./localStorageKeys";
import { CurrentUser } from "@models/user/user";
import { HttpErrorResponse } from "@angular/common/http";

export function handlePortalConsortium(service: NewconService, dialog: MatDialog) {
  let user: CurrentUser;

  try {
    user = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY_USER));
  } catch (e) {
    dialog.open(ModalMessageComponent, {
      data: "Não foi possível verificar o cadastro do seu Usuário da NewCon. Entre em contato com o administrador do sistema."
    })
    return;
  }

  if (user.hasNewConAccess) {
    const loadingRef = dialog.open(ModalLoadingComponent,
    {
      data: "Entrando no Portal da Newcon"
    }
  );

  service.getUrl().pipe(
    catchError(err => {
      loadingRef?.close();

      console.error({err});

      const httpError = err as HttpErrorResponse;
      if (httpError.status !== 502) {

        dialog.open(ModalMessageComponent, {
          data: "Não é possível abrir o portal da NewCon automaticamente. Usuário registrado inválido. Entre em contato com o administrador do sistema."
        })
      } else {
        dialog.open(ModalMessageComponent, {
          data: "Não é possível abrir o portal da NewCon automaticamente. O Portal da NewCon não respondeu adequadamente. Abra um chamado na NewCon para entendimento do problema."
        })
      }
      return EMPTY;
      })
    ).subscribe((result) => {
      loadingRef.close();

      window.open(result.url, '_blank');
    });
  } else {
    dialog.open(ModalMessageComponent, {
      data: "Não é possível abrir o portal da NewCon automaticamente. O seu usuário da NewCon não está informado no seu cadastro. Entre em contato com o administrador do sistema."
    })
  }

}

export const ROUTES: Route[] = [
  {
    path: EnumPath.LOGIN,
    name: EnumPages.LOGIN,
  },
  {
    path: EnumPath.NEW_ACCOUNT,
    name: EnumPages.NEW_ACCOUNT,
  },
  {
    path: EnumPath.RECOVER,
    name: EnumPages.RECOVER,
  },
  {
    path: EnumPath.HOME,
    name: EnumPages.HOME,
  },
  {
    path: EnumPath.CONSORTIUM,
    name: EnumPages.CONSORTIUM,
    permissions: [PERMITION_CONSORTIUM],
    menu: true,
    children: [
      {
        path: '',
        name: EnumPages.PORTAL_CONSORTIUM,
        permissions: [PERMITION_CONSORTIUM_PORTAL_CONSORTIUM],
        action: (service: NewconService, dialog: MatDialog) => handlePortalConsortium(service, dialog)
      },
      {
        path: EnumPath.CONSORTIUM_SALES,
        name: EnumPages.CONSORTIUM_SALES,
        permissions: [PERMITION_CONSORTIUM_SALES],
        children: [
          {
            path: EnumPath.CONSORTIUM_SALES_SALES_TABLE,
            name: EnumPages.CONSORTIUM_SALES_SALES_TABLE,
            permissions: [PERMITION_CONSORTIUM_SALES_SALESTABLE]
          },
          {
            path: EnumPath.CONSORTIUM_SALES_PANEL,
            name: EnumPages.CONSORTIUM_SALES_PANEL,
            permissions: [PERMITION_CONSORTIUM_SALES_PANEL]
          },
        ]
      },
      {
        path: EnumPath.CONSORTIUM_RELATIONSHIP_PANEL,
        name: EnumPages.RELATIONSHIP_PANEL,
        permissions: [PERMITION_CONSORTIUM_RELATIONSHIP_PANEL]
      },
      {
        path: EnumPath.CONSORTIUM_REPORTS,
        name: EnumPages.CONSORTIUM_REPORTS,
        permissions: [PERMITION_CONSORTIUM_REPORTS],
        children: [
          {
            path: EnumPath.CONSORTIUM_REPORTS_BIRTHDATE,
            name: EnumPages.CONSORTIUM_REPORTS_BIRTHDATE,
            permissions: [PERMITION_CONSORTIUM_REPORTS_BIRTHDATE]
          },
          {
            path: EnumPath.CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT,
            name: EnumPages.CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT,
            permissions: [PERMITION_CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT]
          },
          {
            path: EnumPath.CONSORTIUM_REPORTS_COMMISSIONS,
            name: EnumPages.CONSORTIUM_REPORTS_COMMISSIONS,
            permissions: [PERMITION_CONSORTIUM_REPORTS_COMMISSIONS]
          },
        ]
      },
      {
        path: EnumPath.CONSORTIUM_CREDIT_ANALISYS,
        name: EnumPages.CONSORTIUM_CREDIT_ANALISYS,
        permissions: [PERMITION_CONSORTIUM_CREDIT_ANALISYS],
        children: [
          {
            path: EnumPath.CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT,
            name: EnumPages.CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT,
            permissions: [PERMITION_CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT]
          }
        ]
      }
    ]
  },
  {
    path: EnumPath.BANK,
    name: EnumPages.BANK,
    permissions: [PERMITION_BANK],
    menu: true,
    children: [
      {
        path: EnumPath.BANK_RELATIONSHIP_PANEL,
        name: EnumPages.RELATIONSHIP_PANEL,
        permissions: [PERMITION_BANK_RELATIONSHIP_PANEL]
      },
        {
          path: EnumPath.BANK_BAD_DEBT,
          name: EnumPages.BANK_BAD_DEBT,
          permissions: [PERMITION_DEALERS_DEBTORS],
        children: [
          {
            path: EnumPath.DEALERS_DEBT_SETTLEMENT,
            name: EnumPages.DEALERS_DEBT_SETTLEMENT,
            permissions: [PERMITION_DEALERS_SETTLEMENT],
            avoidOnMenu: true
          },
          {
            path: EnumPath.BANK_BAD_DEBT_READ,
            name: EnumPages.BANK_BAD_DEBT_READ,
            permissions: [PERMITION_DEALERS_DEBTORS_READ],
          }
        ]
      },
    ]
  },
  {
    path: EnumPath.INSURANCE,
    name: EnumPages.INSURANCE,
    permissions: [PERMITION_INSURANCE],
    menu: true,
    children: [
      {
        path: EnumPath.INSURANCE_RELATIONSHIP_PANEL,
        name: EnumPages.RELATIONSHIP_PANEL,
        permissions: [PERMITION_INSURANCE_RELATIONSHIP_PANEL]
      },
    ]
  },
  {
    path: EnumPath.SETTINGS,
    name: EnumPages.SETTINGS,
    permissions: [PERMITION_SETTINGS],
    menu: true,
    children: [
      {
        path: EnumPath.SETTINGS_USERS,
        name: EnumPages.SETTINGS_USERS,
        permissions: [PERMITION_USERS],
        children: [
          {
            path: EnumPath.SETTINGS_USERS_CREATE,
            name: EnumPages.SETTINGS_USERS_CREATE,
            permissions: [PERMITION_USERS],
          },
          {
            path: EnumPath.SETTINGS_USERS_UPDATE,
            name: EnumPages.SETTINGS_USERS_UPDATE,
            permissions: [PERMITION_USERS],
          },
          {
            path: EnumPath.SETTINGS_USERS_FILTER,
            name: EnumPages.SETTINGS_USERS_FILTER,
            permissions: [PERMITION_USERS],
          },
        ],
      },
      {
        path: EnumPath.SETTINGS_PROFILE,
        name: EnumPages.SETTINGS_PROFILE,
        permissions: [PERMITION_PROFILE],
        children: [
          {
            path: EnumPath.SETTINGS_PROFILE_CREATE,
            name: EnumPages.SETTINGS_PROFILE_CREATE,
            permissions: [PERMITION_PROFILE_CREATE],
          },
          {
            path: EnumPath.SETTINGS_PROFILE_UPDATE,
            name: EnumPages.SETTINGS_PROFILE_UPDATE,
            permissions: [PERMITION_PROFILE_UPDATE],
          },
          {
            path: EnumPath.SETTINGS_PROFILE_FILTER,
            name: EnumPages.SETTINGS_PROFILE_FILTER,
            permissions: [PERMITION_PROFILE_READ],
          },
        ],
      },
      {
        path: EnumPath.SETTINGS_BANNERS,
        name: EnumPages.SETTINGS_BANNERS,
        permissions: [PERMITION_BANNERS],
        children: [
          {
            path: EnumPath.SETTINGS_BANNERS_CREATE,
            name: EnumPages.SETTINGS_BANNERS_CREATE,
            permissions: [PERMITION_BANNERS_CREATE],
          },
          {
            path: EnumPath.SETTINGS_BANNERS_UPDATE,
            name: EnumPages.SETTINGS_BANNERS_UPDATE,
            permissions: [PERMITION_BANNERS_UPDATE],
          },
          {
            path: EnumPath.SETTINGS_BANNERS_FILTER,
            name: EnumPages.SETTINGS_BANNERS_FILTER,
            permissions: [PERMITION_BANNERS_READ],
          },
        ],
      },
      {
        path: EnumPath.SETTINGS_MESSAGES,
        name: EnumPages.SETTINGS_MESSAGES,
        permissions: [PERMITION_MESSAGES],
        children: [
          {
            path: EnumPath.SETTINGS_MESSAGES_CREATE,
            name: EnumPages.SETTINGS_MESSAGES_CREATE,
            permissions: [PERMITION_MESSAGES_CREATE],
          },
          {
            path: EnumPath.SETTINGS_MESSAGES_UPDATE,
            name: EnumPages.SETTINGS_MESSAGES_UPDATE,
            permissions: [PERMITION_MESSAGES_UPDATE],
          },
          {
            path: EnumPath.SETTINGS_MESSAGES_FILTER,
            name: EnumPages.SETTINGS_MESSAGES_FILTER,
            permissions: [PERMITION_MESSAGES_READ],
          },
        ],
      },
      {
        path: EnumPath.SETTINGS_CONSUMPTION_REPORT,
        name: EnumPages.SETTINGS_CONSUMPTION_REPORT,
        permissions: [PERMITION_CONSUMPTION_REPORT],
        children: [
          {
            path: EnumPath.SETTINGS_CONSUMPTION_REPORT_FILTER,
            name: EnumPages.SETTINGS_CONSUMPTION_REPORT_FILTER,
            permissions: [PERMITION_CONSUMPTION_REPORT_READ],
          },
        ],
      },
      {
        name: EnumPages.SETTINGS_PARAMETERS,
        path: EnumPath.SETTINGS_PARAMETER,
        permissions: [PERMITION_SETTINGS_PARAMETER],
        children: [
          {
            name: EnumPages.SETTINGS_PARAMETERS_FILTER,
            path: EnumPath.SETTINGS_PARAMETER_FILTER,
            permissions: [PERMITION_SETTINGS_PARAMETER_READ],
          },
          {
            name: EnumPages.SETTINGS_PARAMETER_UPDATE,
            path: EnumPath.SETTINGS_PARAMETER_UPDATE,
            permissions: [PERMITION_SETTINGS_PARAMETER_UPDATE],
          },
        ],
      },
      {
        name: EnumPages.SETTINGS_AWARD_PROGRAM,
        path: EnumPath.SETTINGS_AWARD_PROGRAM,
        permissions: [PERMITION_SETTINGS_AWARD_PROGRAM],
        children: [
          {
            name: EnumPages.SETTINGS_AWARD_PROGRAM_FILTER,
            path: EnumPath.SETTINGS_AWARD_PROGRAM_FILTER,
            permissions: [PERMITION_SETTINGS_AWARD_PROGRAM_READ],
          },
          {
            name: EnumPages.SETTINGS_AWARD_PROGRAM,
            path: EnumPath.SETTINGS_AWARD_PROGRAM_CREATE,
            permissions: [PERMITION_SETTINGS_AWARD_PROGRAM_CREATE],
          },
          {
            name: EnumPages.SETTINGS_AWARD_PROGRAM,
            path: EnumPath.SETTINGS_AWARD_PROGRAM_UPDATE,
            permissions: [PERMITION_SETTINGS_AWARD_PROGRAM_UPDATE],
          },
          {
            name: EnumPages.SETTINGS_AWARD_PROGRAM_LOGS_IMPORT,
            path: EnumPath.SETTINGS_AWARD_PROGRAM_LOGS_IMPORT,
            permissions: [PERMITION_SETTINGS_AWARD_PROGRAM_LOGSIMPORT]
          }
        ]
      },
      {
        path: EnumPath.ECONOMICGROUPS,
        name: EnumPages.SETTINGS_ECONOMICGROUPS,
        permissions: [PERMITION_ECONOMICGROUPS],
        children: [
          {
            path: EnumPath.ECONOMICGROUPS_CREATE,
            name: EnumPages.SETTINGS_ECONOMICGROUPS_CREATE,
            permissions: [PERMITION_ECONOMICGROUPS_CREATE],
          },
          {
            path: EnumPath.ECONOMICGROUPS_UPDATE,
            name: EnumPages.SETTINGS_ECONOMICGROUPS_UPDATE,
            permissions: [PERMITION_ECONOMICGROUPS_UPDATE],
          },
          {
            path: EnumPath.ECONOMICGROUPS_FILTER,
            name: EnumPages.SETTINGS_ECONOMICGROUPS_FILTER,
            permissions: [PERMITION_ECONOMICGROUPS_READ],
          },
        ],
      },
      {
        path: EnumPath.SETTINGS_DEALERS,
        name: EnumPages.SETTINGS_DEALERS,
        permissions: [PERMITION_SETTINGS_DEALERS],
        children: [
          {
            path: EnumPath.SETTINGS_DEALERS_CREATE,
            name: EnumPages.SETTINGS_DEALERS_CREATE,
            permissions: [PERMITION_SETTINGS_DEALERS_CREATE],
          },
          {
            path: EnumPath.SETTINGS_DEALERS_UPDATE,
            name: EnumPages.SETTINGS_DEALERS_UPDATE,
            permissions: [PERMITION_SETTINGS_DEALERS_UPDATE],
          },
          {
            path: EnumPath.SETTINGS_DEALERS_FILTER,
            name: EnumPages.SETTINGS_DEALERS_FILTER,
            permissions: [PERMITION_SETTINGS_DEALERS_READ],
          },
        ]
      },
    ],
  },
  {
    path: EnumPath.REPORTS,
    name: EnumPages.REPORTS,
    permissions: [PERMITION_REPORTS],
    menu: true,
    children: [
      {
        path: EnumPath.REPORTS_RECEIVABLES_RECONCILIATION,
        name: EnumPages.REPORTS_RECEIVABLES_RECONCILIATION,
        permissions: [PERMITION_REPORTS_RECEIVABLES_RECONCILIATION],
      }
    ]
  }
];

export const FOOTER_ROUTES_POLITCS: Route[] = [
  {
    name: "Aviso de privacidade",
    path: EnumPath.FOOTER_PRIVACY_ADVERTISING,
  },
  {
    name: "Politica de segurança Cibernética",
    path: EnumPath.FOOTER_CYBERSECURITY_POLICY,
  },
  {
    name: "Política de qualidade e ambiental",
    path: EnumPath.FOOTER_QUALITY_ENVIRONMENT,
  },
  {
    name: "Canal de Denúncia",
    path: EnumPath.FOOTER_REPORTING_CHANNEL,
  },
  {
    name: "Código de Ética",
    path: EnumPath.FOOTER_CODE_ETHICS,
  },
];

export const FOOTER_ROUTES_OPTIONS: Route[] = [
  {
    name: "YAMAHA MOTOR",
    path: EnumPath.FOOTER_YAMAHA_MOTOR,
  },
  {
    name: "YAMAHA MUSICAL",
    path: EnumPath.FOOTER_YAMAHA_MUSICAL,
  },
  {
    name: "YAMAHA NÁUTICA",
    path: EnumPath.FOOTER_YAMAHA_NAUTICA,
  },
];
